var render = function render(_c,_vm){return _c('div',{staticClass:"text",class:[_vm.props.data.size, _vm.props.data.align, _vm.data.staticClass]},[_vm._v("\n    "+_vm._s(_vm.props.data.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }